import React, { Component } from 'react'
import HCaptcha from '@hcaptcha/react-hcaptcha'

class AcademyDetailsModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      displayCaptcha: true,
    }
  }

  handleVerificationSuccess() {
    this.setState({ displayCaptcha: false })
  }

  componentDidUpdate(prevProps) {
    if (this.props.page !== prevProps.page) {
      this.setState({ displayCaptcha: true })
    }
  }

  isUrl(str) {
    const pattern = new RegExp(
      '^(https?:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$',
      'i'
    ) // fragment locator
    return !!pattern.test(str)
  }

  sanitizedProtocolUrl(url) {
    const protocolPattern = new RegExp('^(https:\\/\\/)')

    return !!protocolPattern.test(url) ? url : `http://${url}`
  }

  render() {
    const { academy, i18n } = this.props

    return (
      <div id="academy-details" className="modal fade" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header bg-primary">
              <h5 className="modal-title">
                {this.state.displayCaptcha
                  ? i18n.t('academies.detailsModal.title')
                  : academy.name}
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              {this.state.displayCaptcha ? (
                <div className="description">
                  <p className="captcha-message">
                    {i18n.t('academies.detailsModal.description')}
                  </p>
                  <HCaptcha
                    ref={this.captcha}
                    sitekey={App.HCAPTCHA_SITE_KEY}
                    onVerify={() => this.handleVerificationSuccess()}
                  />
                </div>
              ) : (
                <div className="description">
                  <span>{i18n.t('academies.list.responsible')}</span>
                  <p>{academy.responsible}</p>

                  <span>{i18n.t('academies.list.address')}</span>
                  <p>{academy.address}</p>

                  <span>{i18n.t('academies.list.website')}</span>
                  <p>
                    {this.isUrl(academy.website) ? (
                      <a
                        href={this.sanitizedProtocolUrl(academy.website)}
                        target="_blank"
                        rel="noopener"
                      >
                        {academy.website}
                      </a>
                    ) : (
                      academy.website
                    )}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default AcademyDetailsModal
